// extracted by mini-css-extract-plugin
export default {"container":"QrCode_container__wSYID","qrCode":"QrCode_qrCode__VikvF"};